import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import React from 'react';
import useReportCSS from '../useReportCSS';
import ViewReportKey from './ViewReportKey';
export function ViewReportChartWrapper(props) {
    const { keybelow = true, title = '', groupBy, width = 600, children } = props;
    const myCss = useReportCSS(true);
    return (React.createElement("div", { className: myCss.fullpage }, keybelow ? (React.createElement(Vertical, { gutter: true, padding: true },
        React.createElement(Pane, { classes: { root: myCss.chartTitle } }, title),
        React.createElement(Pane, { grow: true }, "\u00A0"),
        React.createElement(Pane, { style: { alignSelf: 'center', width: '100%' } },
            React.createElement("div", { style: { margin: 'auto', width } }, children)),
        groupBy && (React.createElement(Pane, { style: { alignSelf: 'center', width: '100%' } },
            React.createElement(ViewReportKey, { groupBy: groupBy }))),
        React.createElement(Pane, { grow: true }, "\u00A0"))) : (React.createElement(Horizontal, { gutter: true, padding: true },
        React.createElement(Pane, { grow: true }, "\u00A0"),
        React.createElement(Pane, { style: { alignSelf: 'center', width } }, children),
        groupBy && (React.createElement(Pane, { style: { alignSelf: 'center' } },
            React.createElement(ViewReportKey, { groupBy: groupBy }))),
        React.createElement(Pane, { grow: true }, "\u00A0")))));
}
export default ViewReportChartWrapper;
